import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.method === 'GET') {
          const customRequest = request.clone({
            headers: request
                        .headers.set('Cache-Control', 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0')
                                .set('Pragma', 'no-cache')
                                .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
          });
          return next.handle(customRequest);
        }

        return next.handle(request);
      }
}
